import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  root: {
    padding: '2rem',
    minHeight: 710,
    width: '100%',
    position: 'relative',
    backgroundColor: theme.backgrounds.componentBackground,
    color: theme.texts.main,
    boxSizing: 'border-box',
  },
  rootMobile: {
    padding: '1rem .5rem',
  },
  navigationControls: {
    height: '2.5rem',
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  goBackIcon: {
    position: 'absolute',
    top: 5,
    left: 10,
  },
  contentContainer: {
    marginTop: '1.25rem',
    padding: '0 1rem',
  },
  contentContainerMobile: {
    marginTop: '0.75rem',
  },
  nameInput: {
    width: '100%',
  },
  saveButton: {
    color: theme.palette.primary.main,
    marginTop: '1.5rem',
    width: '100%',
  },
  title: {
    marginTop: '2rem',
  },
}))

export default useStyles
